import { RedirectV2Service } from "../presentation/services/RedirectV2Service";

angular.module("nucont").config([
    "NavigationServiceProvider",
    (NavigationServiceProvider) => {
        // <----------------- EMPRESA ----------------- >

        NavigationServiceProvider.setItem({
            title: "Dados",
            uisref: "nucont.accounting.company.dataRedirect",
            cancelredirect: [],
            uisrefparams: ["source"],
            activeStates: [
                "nucont.accounting.company.dataManagement",
                "nucont.accounting.company.department.accounting.import",
                "nucont.accounting.company.department.tax.import",
                "nucont.accounting.company.department.personnel.import",
                "nucont.accounting.company.department.financial.import",
                "nucont.accounting.company.department.tax.edit",
                "nucont.accounting.company.department.personnel.edit",
                "nucont.accounting.company.department.financial.edit",
                "nucont.accounting.company.department.financial.scenarios",

                "nucont.accounting.edit-company",
                "nucont.accounting.company.department.accounting.scenarios"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-settings-01",
            available: [
                "nucont.accounting.company.*",
                "nucont.accounting.edit-company"
            ],
            flag: [
                "Contabilidade",
                "Contabil",
                "ContabilidadeTrialPro",
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Fiscal",
                "Pessoal",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"],
            position: 0
        });

        NavigationServiceProvider.setItem({
            title: "Parametrização",
            uisref: "nucont.accounting.company.parameterizationOnDemand",
            cancelredirect: [],
            uisrefparams: ["source"],
            activeStates: [
                "nucont.accounting.company.parameterizationOnDemand"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-edit-02",
            available: [
                "nucont.accounting.company.*",
                "nucont.accounting.edit-company"
            ],
            flag: [
                "Contabilidade",
                "Contabil",
                "ContabilidadeTrialPro",
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Fiscal",
                "Pessoal",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"],
            position: 0,
            accountingPlan: {
                module: { name: "ImportData", source: "accounting" }
            }
        });

        NavigationServiceProvider.setItem({
            title: "Contabilidades",
            uisref: "nucont.accountings.customers",
            activeStates: [
                "nucont.accountings.customers",
                "nucont.accountings.trial"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-store-02",
            available: [
                "nucont.accounting.nps.*",
                "nucont.accounting.reporting-center.*",
                "nucont.accounting.groups.overview",
                "nucont.accounting.groups.indicators",
                "nucont.accounting.groups.monitoring.*",
                "nucont.accountings",
                "nucont.publicvariablesIndicatorsChart.*",
                "nucont.admin-users",
                "nucont.admin-users.create",
                "nucont.accounting.monitoring.*",
                "nucont.accounting.prospect",
                "nucont.accounting.prospect-dashboard",
                "nucont.accounting.contactsManagment.*",
                "nucont.accounting.create-company",
                "nucont.accounting.csc.*",
                "nucont.payments",
                "nucont.accounting.integration.*",
                "nucont.accounting.integrations",
                "nucont.accounting.mySubscription",
                "nucont.accounting.customVariablesIndicatorsChart.*",
                "nucont.employee",
                "nucont.accounting.batch-import",
                "nucont.accounting.manager-users.*",
                "nucont.accountings.customers",
                "nucont.accountings.trial",
                "nucont.accountings.cards",
                "nucont.plans",
                "nucont.accounting.overview.*",
                "nucont.accounting.journey.*",
                "nucont.accounting.journey",
                "nucont.accounting"
            ],
            flag: ["Super", "Sucesso", "NuHacker", "ChampionsLeads", "Heads"],
            position: 1
        });

        NavigationServiceProvider.setItem({
            title: "ADMINISTRATIVO",
            activeStates: ["nucont.accountings"],
            available: [
                "nucont.accountings",
                "nucont.accountings.customers",
                "nucont.plans",
                "nucont.accountings.trial",
                "nucont.admin-users",
                "nucont.admin-users.create",
                "nucont.publicvariablesIndicatorsChart.*"
            ],
            group: true,
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrialPro",
                "Contabil",
                "Fiscal",
                "Pessoal",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            position: 1
        });

        NavigationServiceProvider.setItem({
            title: "ANÁLISES",
            activeStates: ["nucont.accountings"],
            available: [
                "nucont.accounting.group.*",
                "nucont.accounting.company.*",
                "nucont.accounting.groups.edit",
                "nucont.accounting.groups.create",
                "nucont.accounting.edit-company",
                "nucont.accounting.groups.assign"
            ],
            group: true,
            flag: [
                "Contabilidade",
                "Contabil",
                "Fiscal",
                "Pessoal",
                "ContabilidadeTrialPro",
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Empresa",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal",
                "Comercial"
            ],
            position: 1
        });

        NavigationServiceProvider.setItem({
            title: "NAVEGAÇÃO",
            activeStates: ["nucont.accountings"],
            available: [
                "nucont.accounting.nps.*",
                "nucont.accounting.reporting-center.*",
                "nucont.accounting.groups.overview",
                "nucont.accounting.groups.indicators",
                "nucont.accounting.groups.monitoring.*",
                "nucont.accounting.monitoring.*",
                "nucont.accounting.prospect",
                "nucont.accounting.prospect-dashboard",
                "nucont.accounting.contactsManagment.*",
                "nucont.accounting.create-company",
                "nucont.accounting.csc.*",
                "nucont.payments",
                "nucont.accounting.integration.*",
                "nucont.accounting.mySubscription",
                "nucont.accounting.customVariablesIndicatorsChart.*",
                "nucont.employee",
                "nucont.accounting.batch-import",
                "nucont.accounting.manager-users.*",
                "nucont.accounting.integrations",
                "nucont.accounting.overview.*",
                "nucont.accounting.journey.*",
                "nucont.accounting.journey",
                "nucont.accounting"
            ],
            group: true,
            flag: ["Super", "Sucesso", "NuHacker", "ChampionsLeads", "Heads"],
            mediaQuery: ["hide-xs", "hide-sm"],
            position: 1.5
        });

        NavigationServiceProvider.setItem({
            title: "Gestão de Planos",
            uisref: "nucont.plans",
            activeStates: ["nucont.plans"],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-settings-01",
            available: [
                "nucont.accountings",
                "nucont.accountings.customers",
                "nucont.plans",
                "nucont.accountings.trial",
                "nucont.publicvariablesIndicatorsChart.*",
                "nucont.admin-users",
                "nucont.admin-users.create"
            ],
            flag: ["Super", "ChampionsLeads"],
            position: 2
        });

        NavigationServiceProvider.setItem({
            title: "Página Inicial",
            uisref: "nucont.accounting.overview.portfolio.companies.resume",
            cancelredirect: [
                "nucont.accounting.overview.portfolio.companies.resume"
            ],
            activeStates: [
                "nucont.accounting.journey",
                "nucont.accounting.groups.overview",
                "nucont.accounting.groups.monitoring.audit",
                "nucont.accounting.groups.monitoring.health",
                "nucont.accounting.groups.indicators",
                "nucont.accounting.overview.dashboard",
                "nucont.accounting.overview.dashboard.control-panel",
                "nucont.accounting.overview.dashboard.performance",
                "nucont.accounting.overview.dashboard.indicators",
                "nucont.accounting.overview.portfolio",
                "nucont.accounting.overview.portfolio.companies",
                "nucont.accounting.overview.portfolio.groups",
                "nucont.accounting.overview.monitoring",
                "nucont.accounting.overview.monitoring.audit",
                "nucont.accounting.overview.monitoring.health",
                "nucont.accounting.overview.portfolio.companies.resume",
                "nucont.accounting.overview.portfolio.companies.data",
                "nucont.accounting.overview.portfolio.companies.performance",
                "nucont.accounting.overview.portfolio.companies.register",
                "nucont.accounting.overview.portfolio.companies.contacts",
                "nucont.accounting.overview.portfolio.groups.resume",
                "nucont.accounting.overview.portfolio.groups.performance",
                "nucont.accounting"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-home-09",
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal",
                "Pessoal",
                "Fiscal"
            ],
            available: [
                "nucont.accounting.nps.*",
                "nucont.accounting.reporting-center.*",
                "nucont.accounting.groups.overview",
                "nucont.accounting.groups.indicators",
                "nucont.accounting.groups.monitoring.*",
                "nucont.accounting.monitoring.*",
                "nucont.accounting.prospect",
                "nucont.accounting.prospect-dashboard",
                "nucont.accounting.contactsManagment.*",
                "nucont.accounting.create-company",
                "nucont.accounting.csc.*",
                "nucont.payments",
                "nucont.accounting.integration.*",
                "nucont.accounting.mySubscription",
                "nucont.accounting.customVariablesIndicatorsChart.*",
                "nucont.employee",
                "nucont.accounting.batch-import",
                "nucont.accounting.manager-users.*",
                "nucont.accounting.integrations",
                "nucont.accounting.overview.*",
                "nucont.accounting.journey.*",
                "nucont.accounting.journey",
                "nucont.accounting"
            ],
            uisrefparams: ["accountingId"],
            position: 2
        });

        NavigationServiceProvider.setItem({
            title: "",
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal",
                "Pessoal",
                "Fiscal"
            ],
            available: [
                "nucont.accounting.nps.*",
                "nucont.accounting.reporting-center.*",
                "nucont.accounting.groups.overview",
                "nucont.accounting.groups.indicators",
                "nucont.accounting.groups.monitoring.*",
                "nucont.accounting.monitoring.*",
                "nucont.accounting.prospect",
                "nucont.accounting.prospect-dashboard",
                "nucont.accounting.contactsManagment.*",
                "nucont.accounting.create-company",
                "nucont.accounting.csc.*",
                "nucont.payments",
                "nucont.accounting.integration.*",
                "nucont.accounting.mySubscription",
                "nucont.accounting.customVariablesIndicatorsChart.*",
                "nucont.employee",
                "nucont.accounting.batch-import",
                "nucont.accounting.manager-users.*",
                "nucont.accounting.integrations",
                "nucont.accounting.overview.*",
                "nucont.accounting.journey.*",
                "nucont.accounting.journey",
                "nucont.accounting"
            ],
            group: true,
            position: 2
        });

        NavigationServiceProvider.setItem({
            title: "Contatos",
            uisref: "nucont.accounting.contactsManagment.companies",
            activeStates: [
                "nucont.accounting.contactsManagment",
                "nucont.accounting.contactsManagment.companies",
                "nucont.accounting.contactsManagment.others"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-contact-book",
            available: [
                "nucont.accounting.nps.*",
                "nucont.accounting.reporting-center.*",
                "nucont.accounting.groups.overview",
                "nucont.accounting.groups.indicators",
                "nucont.accounting.groups.monitoring.*",
                "nucont.accounting.monitoring.*",
                "nucont.accounting.prospect",
                "nucont.accounting.prospect-dashboard",
                "nucont.accounting.contactsManagment.*",
                "nucont.accounting.create-company",
                "nucont.accounting.csc.*",
                "nucont.payments",
                "nucont.accounting.integration.*",
                "nucont.accounting.mySubscription",
                "nucont.accounting.customVariablesIndicatorsChart.*",
                "nucont.employee",
                "nucont.accounting.batch-import",
                "nucont.accounting.manager-users.*",
                "nucont.accounting.integrations",
                "nucont.accounting.overview.*",
                "nucont.accounting.journey.*",
                "nucont.accounting.journey",
                "nucont.accounting"
            ],
            uisrefparams: ["accountingId"],
            position: 2,
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Fiscal",
                "Pessoal",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"]
        });

        NavigationServiceProvider.setItem({
            title: "Dashboards",
            uisref: "nucont.accounting.company.dashboards.view",
            cancelredirect: ["nucont.accounting.company.dashboards.view"],
            activeStates: [
                "nucont.accounting.company.dashboards.view",
                "nucont.accounting.company.customization.indicators",
                "nucont.accounting.company.customization.graphics",
                "nucont.accounting.company.customization.dashboards"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-chart-03",
            available: [
                "nucont.accounting.company.*",
                "nucont.accounting.edit-company"
            ],
            position: 2,
            uisrefparams: ["accountingId", "id", "source"],
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Fiscal",
                "Pessoal",
                "Empresa",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ]
        });

        NavigationServiceProvider.setItem({
            title: "Gestão de Usuários",
            uisref: "nucont.admin-users",
            activeStates: ["nucont.admin-users", "nucont.admin-users.create"],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-user-settings-01",
            available: [
                "nucont.accountings",
                "nucont.publicvariablesIndicatorsChart.*",
                "nucont.admin-users",
                "nucont.admin-users.create",
                "nucont.accountings.customers",
                "nucont.accountings.trial",
                "nucont.plans"
            ],
            flag: ["Super"],
            position: 3
        });

        NavigationServiceProvider.setItem({
            title: "Central de Dash",
            uisref: "nucont.accounting.reporting-center.generateds",
            activeStates: ["nucont.accounting.reporting-center.generateds"],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-share-08",
            available: [
                "nucont.accounting.nps.*",
                "nucont.accounting.reporting-center.*",
                "nucont.accounting.groups.overview",
                "nucont.accounting.groups.indicators",
                "nucont.accounting.groups.monitoring.*",
                "nucont.accounting.monitoring.*",
                "nucont.accounting.prospect",
                "nucont.accounting.prospect-dashboard",
                "nucont.accounting.contactsManagment.*",
                "nucont.accounting.create-company",
                "nucont.accounting.csc.*",
                "nucont.accounting.mySubscription",
                "nucont.accounting.customVariablesIndicatorsChart.*",
                "nucont.accounting.batch-import",
                "nucont.accounting.manager-users.*",
                "nucont.accounting.integrations",
                "nucont.accounting.integration.*",
                "nucont.accounting.overview.*",
                "nucont.accounting.journey.*",
                "nucont.accounting.journey",
                "nucont.accounting"
            ],
            position: 3,
            uisrefparams: ["accountingId"],
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Fiscal",
                "Pessoal",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"]
        });

        NavigationServiceProvider.setItem({
            title: "Auditoria",
            uisref: "nucont.accounting.company.monitoring.audit",
            cancelredirect: ["nucont.accounting.company.monitoring.audit"],
            activeStates: [
                "nucont.accounting.company.monitoring.audit",
                "nucont.accounting.company.monitoring.audit.config"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-flag-02",
            available: ["nucont.accounting.company.*"],
            uisrefparams: ["accountingId", "id", "source"],
            position: 3,
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"]
        });

        NavigationServiceProvider.setItem({
            title: "Avaliações",
            uisref: "nucont.accounting.nps.view.feedbacksReports",
            uisrefparams: ["accountingId"],
            group: false,

            activeStates: [
                "nucont.accounting.nps.view.overview",
                "nucont.accounting.nps.view",
                "nucont.accounting.nps.dashboard",
                "nucont.accounting.nps.view.feedbacksReports"
            ],
            position: 4,
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Contabilidade",
                "Beta"
            ],
            mediaQuery: ["hide-xs", "hide-sm"],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-star-half",
            available: [
                "nucont.accounting.nps.*",
                "nucont.accounting.reporting-center.*",
                "nucont.accounting.groups.overview",
                "nucont.accounting.groups.indicators",
                "nucont.accounting.groups.monitoring.*",
                "nucont.accounting.monitoring.*",
                "nucont.accounting.prospect",
                "nucont.accounting.prospect-dashboard",
                "nucont.accounting.contactsManagment.*",
                "nucont.accounting.create-company",
                "nucont.accounting.csc.*",
                "nucont.payments",
                "nucont.accounting.integration.*",
                "nucont.accounting.mySubscription",
                "nucont.accounting.customVariablesIndicatorsChart.*",
                "nucont.employee",
                "nucont.accounting.batch-import",
                "nucont.accounting.manager-users.*",
                "nucont.accounting.integrations",
                "nucont.accounting.overview.*",
                "nucont.accounting.journey.*",
                "nucont.accounting.journey",
                "nucont.accounting"
            ],
            accountingPlan: {
                feature: "NPS"
            }
        });

        NavigationServiceProvider.setItem({
            title: "Demonstrações",
            uisref: "nucont.accounting.company.demonstrationsRedirect",
            cancelredirect: [
                "nucont.accounting.company.demonstrationsRedirect"
            ],
            activeStates: [
                "nucont.accounting.company.demonstrations.accounting.dre",
                "nucont.accounting.company.demonstrations.accounting.balancesheet",
                "nucont.accounting.company.demonstrations.accounting.balance",
                "nucont.accounting.company.demonstrations.fin.dre"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-table",
            available: [
                "nucont.accounting.company.*",
                "nucont.accounting.edit-company"
            ],
            position: 4,
            uisrefparams: ["accountingId", "id", "scenarioId"],
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Empresa",
                "Financeiro",
                "Gestor"
            ],
            mediaQuery: ["hide-xs", "hide-sm"]
        });

        NavigationServiceProvider.setItem({
            title: "RELACIONAMENTO",
            activeStates: ["nucont.accountings"],
            available: [
                "nucont.accounting.nps.*",
                "nucont.accounting.reporting-center.*",
                "nucont.accounting.groups.overview",
                "nucont.accounting.groups.indicators",
                "nucont.accounting.groups.monitoring.*",
                "nucont.accounting.monitoring.*",
                "nucont.accounting.prospect",
                "nucont.accounting.prospect-dashboard",
                "nucont.accounting.contactsManagment.*",
                "nucont.accounting.create-company",
                "nucont.accounting.csc.*",
                "nucont.payments",
                "nucont.accounting.integration.*",
                "nucont.accounting.mySubscription",
                "nucont.accounting.customVariablesIndicatorsChart.*",
                "nucont.employee",
                "nucont.accounting.batch-import",
                "nucont.accounting.manager-users.*",
                "nucont.accounting.integrations",
                "nucont.accounting.overview.*",
                "nucont.accounting.journey.*",
                "nucont.accounting.journey",
                "nucont.accounting"
            ],
            group: true,
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrialPro",
                "Contabil",
                "Fiscal",
                "Pessoal",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"],
            position: 4.5
        });

        NavigationServiceProvider.setItem({
            title: "Integrações",
            uisref: "nucont.accounting.integrations",
            activeStates: [
                "nucont.accounting.integrations",
                "nucont.accounting.integration",
                "nucont.accounting.integration.omie",
                "nucont.accounting.integration.contaazul",
                "nucont.accounting.integration.nibo",
                "nucont.accounting.integration.fortes",
                "nucont.accounting.integration.dominioideen",
                "nucont.accounting.integration.contabit",
                "nucont.accounting.integration.serpro"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-puzzle",
            available: [
                "nucont.accounting.nps.*",
                "nucont.accounting.reporting-center.*",
                "nucont.accounting.groups.overview",
                "nucont.accounting.groups.indicators",
                "nucont.accounting.groups.monitoring.*",
                "nucont.accounting.monitoring.*",
                "nucont.accounting.prospect",
                "nucont.accounting.prospect-dashboard",
                "nucont.accounting.contactsManagment.*",
                "nucont.accounting.create-company",
                "nucont.accounting.csc.*",
                "nucont.payments",
                "nucont.accounting.integration.*",
                "nucont.accounting.mySubscription",
                "nucont.accounting.customVariablesIndicatorsChart.*",
                "nucont.employee",
                "nucont.accounting.batch-import",
                "nucont.accounting.manager-users.*",
                "nucont.accounting.integrations",
                "nucont.accounting.overview.*",
                "nucont.accounting.journey.*",
                "nucont.accounting.journey",
                "nucont.accounting"
            ],
            uisrefparams: ["accountingId"],
            position: 5,
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrialPro",
                "Contabil",
                "Financeiro",
                "Gestor",
                "Fiscal",
                "Pessoal",
                "Pessoal e Fiscal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"]
        });

        NavigationServiceProvider.setItem({
            title: "Plano de Contas",
            uisref: "nucont.accounting.company.accountsPlan",
            cancelredirect: ["nucont.accounting.company.accountsPlan"],
            activeStates: ["nucont.accounting.company.accountsPlan"],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-left-to-right-list-bullet",
            available: [
                "nucont.accounting.company.*",
                "nucont.accounting.edit-company"
            ],
            uisrefparams: ["accountingId", "id", "source"],
            position: 5,
            flag: [
                "Contabilidade",
                "Contabil",
                "ContabilidadeTrialPro",
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"],
            contract: ["Standard", "Professional", "Expert"],
            accountingPlan: {
                module: { name: "AccountsPlan" }
            }
        });

        NavigationServiceProvider.setItem({
            title: "Automações",
            uisref: "nucont.accounting.reporting-center.automations",
            activeStates: ["nucont.accounting.reporting-center.automations"],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-bot",
            available: [
                "nucont.accounting.nps.*",
                "nucont.accounting.reporting-center.*",
                "nucont.accounting.groups.overview",
                "nucont.accounting.groups.indicators",
                "nucont.accounting.groups.monitoring.*",
                "nucont.accounting.monitoring.*",
                "nucont.accounting.prospect",
                "nucont.accounting.prospect-dashboard",
                "nucont.accounting.contactsManagment.*",
                "nucont.accounting.create-company",
                "nucont.accounting.csc.*",
                "nucont.accounting.mySubscription",
                "nucont.accounting.customVariablesIndicatorsChart.*",
                "nucont.accounting.batch-import",
                "nucont.accounting.manager-users.*",
                "nucont.accounting.integrations",
                "nucont.accounting.integration.*",
                "nucont.accounting.overview.*",
                "nucont.accounting.journey.*",
                "nucont.accounting.journey",
                "nucont.accounting"
            ],
            position: 6,
            uisrefparams: ["accountingId", "id"],
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Fiscal",
                "Pessoal",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"]
        });

        NavigationServiceProvider.setItem({
            title: "ANÁLISE PLUS",
            activeStates: ["nucont.accountings"],
            available: [
                "nucont.accounting.company.*",
                "nucont.accounting.edit-company"
            ],
            group: true,
            flag: [
                "Contabilidade",
                "Contabil",
                "Fiscal",
                "Pessoal",
                "ContabilidadeTrialPro",
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal",
                "Comercial"
            ],

            position: 6
        });

        NavigationServiceProvider.setItem({
            title: "Objetivos",
            uisref: "nucont.accounting.company.monitoring.health",
            cancelredirect: ["nucont.accounting.company.monitoring.health"],
            activeStates: [
                "nucont.accounting.company.monitoring.health",
                "nucont.accounting.company.monitoring.health.config"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-target-01",
            available: [
                "nucont.accounting.company.*",
                "nucont.accounting.edit-company"
            ],
            uisrefparams: ["accountingId", "id", "source"],
            position: 6,
            flag: [
                "Contabilidade",
                "Contabil",
                "Fiscal",
                "Pessoal",
                "ContabilidadeTrialPro",
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal",
                "Comercial"
            ],
            mediaQuery: ["hide-xs", "hide-sm"],
            contract: ["Standard", "Professional", "Expert"]
        });

        NavigationServiceProvider.setItem({
            title: "Gestão de usuários",
            uisref: "nucont.accounting.manager-users.employee",
            activeStates: [
                "nucont.accounting.manager-users.employee",
                "nucont.accounting.manager-users.businessman"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-user-settings-01",
            available: [
                "nucont.accounting.nps.*",
                "nucont.accounting.reporting-center.*",
                "nucont.accounting.groups.overview",
                "nucont.accounting.groups.indicators",
                "nucont.accounting.groups.monitoring.*",
                "nucont.accounting.monitoring.*",
                "nucont.accounting.prospect",
                "nucont.accounting.prospect-dashboard",
                "nucont.accounting.contactsManagment.*",
                "nucont.accounting.create-company",
                "nucont.accounting.csc.*",
                "nucont.payments",
                "nucont.accounting.integration.*",
                "nucont.accounting.mySubscription",
                "nucont.accounting.customVariablesIndicatorsChart.*",
                "nucont.employee",
                "nucont.accounting.batch-import",
                "nucont.accounting.manager-users.*",
                "nucont.accounting.integrations",
                "nucont.accounting.overview.*",
                "nucont.accounting.journey.*",
                "nucont.accounting.journey",
                "nucont.accounting"
            ],
            uisrefparams: ["accountingId"],
            position: 7,
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade"
            ],
            mediaQuery: ["hide-xs", "hide-sm"],
            accountingPlan: {
                feature: "UsersManagement"
            }
        });

        NavigationServiceProvider.setItem({
            title: "Projeção",
            uisref: "nucont.accounting.company.projection",
            cancelredirect: [
                "nucont.accounting.company.projection",
                "nucont.accounting.company.projection.accounting",
                "nucont.accounting.company.projection.fin",
                "nucont.accounting.company.projection.tax",
                "nucont.accounting.company.projection.personnel"
            ],
            activeStates: [
                "nucont.accounting.company.projection.accounting",
                "nucont.accounting.company.projection.fin",
                "nucont.accounting.company.projection.tax",
                "nucont.accounting.company.projection.personnel"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-chart-up",
            available: [
                "nucont.accounting.company.*",
                "nucont.accounting.edit-company"
            ],
            uisrefparams: ["accountingId", "id", "source", "accountPlanType"],
            position: 7,
            flag: [
                "Contabilidade",
                "Contabil",
                "Fiscal",
                "Pessoal",
                "ContabilidadeTrialPro",
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"],
            contract: ["Standard", "Professional", "Expert"],
            htmlId: "SidebarProjectionItem"
        });

        NavigationServiceProvider.setItem({
            title: "Orçamento",
            uisref: "nucont.accounting.company.budget",
            cancelredirect: [
                "nucont.accounting.company.budget",
                "nucont.accounting.company.budget.accounting",
                "nucont.accounting.company.budget.fin",
                "nucont.accounting.company.budget.tax",
                "nucont.accounting.company.budget.personnel"
            ],
            activeStates: [
                "nucont.accounting.company.budget.accounting",
                "nucont.accounting.company.budget.fin",
                "nucont.accounting.company.budget.tax",
                "nucont.accounting.company.budget.personnel"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-coins-01",
            available: [
                "nucont.accounting.company.*",
                "nucont.accounting.edit-company"
            ],
            uisrefparams: ["accountingId", "id", "source", "accountPlanType"],
            position: 7,
            flag: [
                "Contabilidade",
                "Contabil",
                "Fiscal",
                "Pessoal",
                "ContabilidadeTrialPro",
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"],
            contract: ["Standard", "Professional", "Expert"],
            htmlId: "SidebarBudgetItem"
        });

        NavigationServiceProvider.setItem({
            title: "PERSONALIZAÇÃO",
            activeStates: ["nucont.accountings"],
            available: [
                "nucont.accounting.nps.*",
                "nucont.accounting.reporting-center.*",
                "nucont.accounting.groups.overview",
                "nucont.accounting.groups.indicators",
                "nucont.accounting.groups.monitoring.*",
                "nucont.accounting.monitoring.*",
                "nucont.accounting.prospect",
                "nucont.accounting.prospect-dashboard",
                "nucont.accounting.contactsManagment.*",
                "nucont.accounting.create-company",
                "nucont.accounting.csc.*",
                "nucont.payments",
                "nucont.accounting.integration.*",
                "nucont.accounting.mySubscription",
                "nucont.accounting.customVariablesIndicatorsChart.*",
                "nucont.employee",
                "nucont.accounting.batch-import",
                "nucont.accounting.manager-users.*",
                "nucont.accounting.integrations",
                "nucont.accounting.overview.*",
                "nucont.accounting.journey.*",
                "nucont.accounting.journey",
                "nucont.accounting"
            ],
            group: true,
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "Gestor",
                "Contabil"
            ],
            mediaQuery: ["hide-xs", "hide-sm"],
            position: 7.9
        });

        NavigationServiceProvider.setItem({
            title: "ENTREGAS",
            activeStates: ["nucont.accountings"],
            available: [
                "nucont.accounting.company.*",
                "nucont.accounting.edit-company"
            ],
            group: true,
            flag: [
                "Contabilidade",
                "Contabil",
                "ContabilidadeTrialPro",
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Empresa",
                "Fiscal",
                "Pessoal",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal",
                "Comercial"
            ],
            mediaQuery: ["hide-xs", "hide-sm"],
            position: 8
        });

        NavigationServiceProvider.setItem({
            title: "CONFIGURAÇÕES",
            activeStates: ["nucont.accountings"],
            available: [
                "nucont.accountings",
                "nucont.accountings.customers",
                "nucont.accountings.trial",
                "nucont.plans",
                "nucont.publicvariablesIndicatorsChart.*",
                "nucont.admin-users",
                "nucont.admin-users.create"
            ],
            group: true,
            uisrefparams: ["accountingId", "id", "source"],
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrialPro",
                "Contabil",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal",
                "Fiscal",
                "Pessoal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"],
            position: 9
        });

        NavigationServiceProvider.setItem({
            title: "Central de Dash",
            uisref: "nucont.accounting.company.reports",
            activeStates: ["nucont.accounting.company.reports"],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-share-08",
            available: [
                "nucont.accounting.company.*",
                "nucont.accounting.edit-company"
            ],
            position: 9,
            uisrefparams: ["accountingId", "id"],
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Empresa",
                "Fiscal",
                "Pessoal",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"],
            accountingPlan: {
                module: { name: "Reports" }
            }
        });
        NavigationServiceProvider.setItem({
            title: "Customização",
            customHref: ({ accountingId }) => {
                return new RedirectV2Service().getUrl({
                    accountingId
                });
            },
            // uisref: "nucont.accounting.customVariablesIndicatorsChart.variables",
            activeStates: [
                "nucont.accounting.customVariablesIndicatorsChart.variables",
                "nucont.accounting.customVariablesIndicatorsChart.indicators",
                "nucont.accounting.customVariablesIndicatorsChart.charts"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-ai-beautify",
            available: [
                "nucont.accounting.nps.*",
                "nucont.accounting.reporting-center.*",
                "nucont.accounting.groups.overview",
                "nucont.accounting.groups.indicators",
                "nucont.accounting.groups.monitoring.*",
                "nucont.accounting.monitoring.*",
                "nucont.accounting.prospect",
                "nucont.accounting.prospect-dashboard",
                "nucont.accounting.contactsManagment.*",
                "nucont.accounting.create-company",
                "nucont.accounting.csc.*",
                "nucont.payments",
                "nucont.accounting.integration.*",
                "nucont.accounting.mySubscription",
                "nucont.accounting.customVariablesIndicatorsChart.*",
                "nucont.employee",
                "nucont.accounting.batch-import",
                "nucont.accounting.manager-users.*",
                "nucont.accounting.integrations",
                "nucont.accounting.overview.*",
                "nucont.accounting.journey.*",
                "nucont.accounting.journey",
                "nucont.accounting"
            ],
            uisrefparams: ["accountingId"],
            position: 10,
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "Gestor",
                "Contabil",
                "Financeiro"
            ],
            badgeContract: true,
            contract: ["Standard", "Expert", "Professional"],
            mediaQuery: ["hide-xs", "hide-sm"],
            accountingPlan: {
                module: { name: "GeneralCustomization" }
            }
        });

        NavigationServiceProvider.setItem({
            title: "Outros",
            activeStates: [
                "nucont.accounting.batch-import",
                "nucont.accounting.prospect",
                "nucont.accounting.prospect-dashboard"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-more-horizontal",
            submenu: [
                {
                    title: "Importação em lote",
                    uisref: "nucont.accounting.batch-import",
                    uisrefparams: ["accountingId"],
                    icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-upload-03",
                    activeStates: ["nucont.accounting.batch-import"],
                    available: [
                        "nucont.accounting.nps.*",
                        "nucont.accounting.reporting-center.*",
                        "nucont.accounting.groups.overview",
                        "nucont.accounting.groups.indicators",
                        "nucont.accounting.groups.monitoring.*",
                        "nucont.accounting.monitoring.*",
                        "nucont.accounting.prospect",
                        "nucont.accounting.prospect-dashboard",
                        "nucont.accounting.contactsManagment.*",
                        "nucont.accounting.create-company",
                        "nucont.accounting.csc.*",
                        "nucont.payments",
                        "nucont.accounting.integration.*",
                        "nucont.accounting.mySubscription",
                        "nucont.accounting.customVariablesIndicatorsChart.*",
                        "nucont.employee",
                        "nucont.accounting.batch-import",
                        "nucont.accounting.manager-users.*",
                        "nucont.accounting.integrations",
                        "nucont.accounting.overview.*",
                        "nucont.accounting.journey.*",
                        "nucont.accounting.journey",
                        "nucont.accounting"
                    ],
                    flag: [
                        "Super",
                        "Sucesso",
                        "NuHacker",
                        "ChampionsLeads",
                        "Heads",
                        "Contabilidade",
                        "ContabilidadeTrialPro",
                        "ContabilidadeTrial",
                        "Gestor",
                        "Contabil",
                        "Fiscal",
                        "Pessoal",
                        "Financeiro",
                        "Pessoal e Fiscal",
                        "Comercial"
                    ]
                },
                {
                    title: "Leads",
                    uisref: "nucont.accounting.prospect",
                    uisrefparams: ["accountingId"],
                    icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-target-03",
                    activeStates: [
                        "nucont.accounting.prospect",
                        "nucont.accounting.prospect-dashboard"
                    ],
                    available: [
                        "nucont.accounting.nps.*",
                        "nucont.accounting.reporting-center.*",
                        "nucont.accounting.groups.overview",
                        "nucont.accounting.groups.indicators",
                        "nucont.accounting.groups.monitoring.*",
                        "nucont.accounting.monitoring.*",
                        "nucont.accounting.prospect",
                        "nucont.accounting.prospect-dashboard",
                        "nucont.accounting.contactsManagment.*",
                        "nucont.accounting.create-company",
                        "nucont.accounting.csc.*",
                        "nucont.payments",
                        "nucont.accounting.integration.*",
                        "nucont.accounting.mySubscription",
                        "nucont.accounting.customVariablesIndicatorsChart.*",
                        "nucont.employee",
                        "nucont.accounting.batch-import",
                        "nucont.accounting.manager-users.*",
                        "nucont.accounting.integrations",
                        "nucont.accounting.overview.*",
                        "nucont.accounting.journey.*",
                        "nucont.accounting.journey",
                        "nucont.accounting"
                    ],
                    flag: [
                        "Super",
                        "Sucesso",
                        "NuHacker",
                        "ChampionsLeads",
                        "Heads",
                        "Contabilidade",
                        "ContabilidadeTrialPro",
                        "ContabilidadeTrial",
                        "Gestor",
                        "Contabil",
                        "Fiscal",
                        "Pessoal",
                        "Financeiro",
                        "Pessoal e Fiscal",
                        "Comercial"
                    ]
                }
            ],
            available: [
                "nucont.accounting.nps.*",
                "nucont.accounting.reporting-center.*",
                "nucont.accounting.groups.overview",
                "nucont.accounting.groups.indicators",
                "nucont.accounting.groups.monitoring.*",
                "nucont.accounting.monitoring.*",
                "nucont.accounting.prospect",
                "nucont.accounting.prospect-dashboard",
                "nucont.accounting.contactsManagment.*",
                "nucont.accounting.create-company",
                "nucont.accounting.csc.*",
                "nucont.payments",
                "nucont.accounting.integration.*",
                "nucont.accounting.mySubscription",
                "nucont.accounting.customVariablesIndicatorsChart.*",
                "nucont.employee",
                "nucont.accounting.batch-import",
                "nucont.accounting.manager-users.*",
                "nucont.accounting.integrations",
                "nucont.accounting.overview.*",
                "nucont.accounting.journey.*",
                "nucont.accounting.journey",
                "nucont.accounting"
            ],
            position: 11,
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrialPro",
                "ContabilidadeTrial",
                "Gestor",
                "Contabil",
                "Fiscal",
                "Pessoal",
                "Financeiro",
                "Pessoal e Fiscal",
                "Comercial"
            ]
        });

        // <----------------- GRUPO ----------------- >

        NavigationServiceProvider.setItem({
            title: "Configurações",
            uisref: "nucont.accounting.groups.edit",
            activeStates: [
                "nucont.accounting.groups.edit",
                "nucont.accounting.groups.create",
                "nucont.accounting.groups.assign"
            ],
            icon: "fas fa-cog",
            available: [
                "nucont.accounting.group.*",
                "nucont.accounting.groups.edit",
                "nucont.accounting.groups.create",
                "nucont.accounting.groups.assign"
            ],
            uisrefparams: ["accountingId", "id"],
            flag: [
                "Contabilidade",
                "Contabil",
                "ContabilidadeTrialPro",
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Fiscal",
                "Pessoal",
                "Financeiro",
                "Gestor"
            ],
            mediaQuery: ["hide-xs", "hide-sm"],
            position: 0
        });

        NavigationServiceProvider.setItem({
            title: "Dashboards",
            uisref: "nucont.accounting.group.dashboards.view",
            cancelredirect: ["nucont.accounting.group.dashboards.view"],
            activeStates: ["nucont.accounting.group.dashboards.view"],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-chart-03",
            available: [
                "nucont.accounting.group.*",
                "nucont.accounting.groups.edit",
                "nucont.accounting.groups.create",
                "nucont.accounting.groups.assign"
            ],
            position: 2,
            uisrefparams: ["accountingId", "id", "source"],
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Fiscal",
                "Pessoal",
                "Empresa",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"]
        });

        NavigationServiceProvider.setItem({
            title: "Demonstrações",
            uisref: "nucont.accounting.group.demonstrationsRedirect",
            cancelredirect: ["nucont.accounting.group.demonstrationsRedirect"],
            activeStates: [
                "nucont.accounting.group.demonstrations.accounting.dre",
                "nucont.accounting.group.demonstrations.accounting.balancesheet",
                "nucont.accounting.group.demonstrations.accounting.balance",
                "nucont.accounting.group.demonstrations.fin.dre"
            ],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-table",
            available: [
                "nucont.accounting.group.*",
                "nucont.accounting.groups.edit",
                "nucont.accounting.groups.create",
                "nucont.accounting.groups.assign"
            ],
            position: 4,
            uisrefparams: ["accountingId", "id"],
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Empresa",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            contract: [
                "Standard",
                "Professional",
                "Expert",
                "ExpertFinanceiro"
            ],
            mediaQuery: ["hide-xs", "hide-sm"]
        });

        NavigationServiceProvider.setItem({
            title: "Plano de Contas",
            uisref: "nucont.accounting.group.accountsPlan",
            cancelredirect: ["nucont.accounting.group.accountsPlan"],
            activeStates: ["nucont.accounting.group.accountsPlan"],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-left-to-right-list-bullet",
            available: [
                "nucont.accounting.group.*",
                "nucont.accounting.groups.edit",
                "nucont.accounting.groups.create",
                "nucont.accounting.groups.assign"
            ],
            uisrefparams: ["accountingId", "id", "source"],
            position: 5,
            flag: [
                "Contabilidade",
                "Contabil",
                "ContabilidadeTrialPro",
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"]
        });

        NavigationServiceProvider.setItem({
            title: "ENTREGAS",
            activeStates: ["nucont.accountings"],
            available: [
                "nucont.accounting.group.*",
                "nucont.accounting.groups.edit",
                "nucont.accounting.groups.create",
                "nucont.accounting.groups.assign"
            ],
            group: true,
            flag: [
                "Contabilidade",
                "Contabil",
                "ContabilidadeTrialPro",
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Empresa",
                "Fiscal",
                "Pessoal",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            mediaQuery: ["hide-xs", "hide-sm"],
            position: 6
        });

        NavigationServiceProvider.setItem({
            title: "Central de Dash",
            uisref: "nucont.accounting.group.reports",
            activeStates: ["nucont.accounting.group.reports"],
            icon: "hgi hgi-stroke icon-bold hgi-rounded hgi-share-08",
            available: [
                "nucont.accounting.group.*",
                "nucont.accounting.groups.edit",
                "nucont.accounting.groups.create",
                "nucont.accounting.groups.assign"
            ],
            position: 7,
            uisrefparams: ["accountingId", "id"],
            flag: [
                "Super",
                "Sucesso",
                "NuHacker",
                "ChampionsLeads",
                "Heads",
                "Contabilidade",
                "ContabilidadeTrial",
                "ContabilidadeTrialPro",
                "Contabil",
                "Comercial",
                "Empresa",
                "Fiscal",
                "Pessoal",
                "Financeiro",
                "Gestor",
                "Pessoal e Fiscal"
            ],
            accountingPlan: {
                module: { name: "Reports" }
            },

            mediaQuery: ["hide-xs", "hide-sm"]
        });
    }
]);
